/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import type { OutMerchantDTO } from "./OutMerchantDTO";
import { OutMerchantDTOFromJSON, OutMerchantDTOFromJSONTyped, OutMerchantDTOToJSON } from "./OutMerchantDTO";
import type { PublicPlatformDTO } from "./PublicPlatformDTO";
import {
  PublicPlatformDTOFromJSON,
  PublicPlatformDTOFromJSONTyped,
  PublicPlatformDTOToJSON
} from "./PublicPlatformDTO";

/**
 *
 * @export
 * @interface OutFeaturedCategoriesDTO
 */
export interface OutFeaturedCategoriesDTO {
  /**
   *
   * @type {number}
   * @memberof OutFeaturedCategoriesDTO
   */
  id: number;
  /**
   *
   * @type {PublicPlatformDTO}
   * @memberof OutFeaturedCategoriesDTO
   */
  platform: PublicPlatformDTO;
  /**
   *
   * @type {string}
   * @memberof OutFeaturedCategoriesDTO
   */
  categoryTitle: string;
  /**
   *
   * @type {string}
   * @memberof OutFeaturedCategoriesDTO
   */
  trackingUrl: string;
  /**
   *
   * @type {string}
   * @memberof OutFeaturedCategoriesDTO
   */
  slug: string;
  /**
   *
   * @type {OutMerchantDTO}
   * @memberof OutFeaturedCategoriesDTO
   */
  merchant: OutMerchantDTO;
}

/**
 * Check if a given object implements the OutFeaturedCategoriesDTO interface.
 */
export function instanceOfOutFeaturedCategoriesDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "platform" in value;
  isInstance = isInstance && "categoryTitle" in value;
  isInstance = isInstance && "trackingUrl" in value;
  isInstance = isInstance && "slug" in value;
  isInstance = isInstance && "merchant" in value;

  return isInstance;
}

export function OutFeaturedCategoriesDTOFromJSON(json: any): OutFeaturedCategoriesDTO {
  return OutFeaturedCategoriesDTOFromJSONTyped(json, false);
}

export function OutFeaturedCategoriesDTOFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): OutFeaturedCategoriesDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    platform: PublicPlatformDTOFromJSON(json["platform"]),
    categoryTitle: json["categoryTitle"],
    trackingUrl: json["trackingUrl"],
    slug: json["slug"],
    merchant: OutMerchantDTOFromJSON(json["merchant"])
  };
}

export function OutFeaturedCategoriesDTOToJSON(value?: OutFeaturedCategoriesDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    platform: PublicPlatformDTOToJSON(value.platform),
    categoryTitle: value.categoryTitle,
    trackingUrl: value.trackingUrl,
    slug: value.slug,
    merchant: OutMerchantDTOToJSON(value.merchant)
  };
}
